import { type Dispatch, type SetStateAction, useEffect, useState } from 'react'

import { getUser } from 'commons/utils/user'
import { Alert, Checkbox, Icon, Modal, Select } from 'components'
import { type CustomBoolean, TypesValidations } from 'constants/enums'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { setDuplicateOrder } from 'store/SalesOrderContext/salesOrderSlice'
import { useSelector } from 'store/store'

import { Container, Content, ContentDate, DescriptionWrapper, InputDate, Label } from './styles'

export interface PropsModal {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  handleDuplicated: (() => void) | undefined
}

const ModalDuplicate = ({ open, setOpen, handleDuplicated }: PropsModal) => {
  const [dataDelivery, setDataDelivery] = useState<string>('')
  const [typeMaterial, setTypeMaterial] = useState<CustomBoolean>(TypesValidations.NO)
  const [keepMaterial, setKeepMaterial] = useState<boolean>(true)
  const [showWarning, setShowWarning] = useState<boolean>(false)
  const { orderNumber } = useParams()
  const { duplicateOrder, draftBody } = useSelector((state) => state.salesOrder)
  const dispatch = useDispatch()
  const materialOptions = [
    {
      title: 'Padrão',
      value: TypesValidations.NO,
    },
    {
      title: 'MTO',
      value: TypesValidations.YES,
    },
  ]

  const handleTypeChange = (newType: CustomBoolean) => {
    if (draftBody.fl_mto_prep === TypesValidations.NO && newType === TypesValidations.YES) {
      setShowWarning(true)
      setKeepMaterial(false)
    } else {
      setShowWarning(false)
      setKeepMaterial(duplicateOrder.Clientes[0].fl_dupl_matr === TypesValidations.YES)
    }

    setTypeMaterial(newType)
    dispatch(
      setDuplicateOrder({
        ...duplicateOrder,
        Clientes: [{ ...duplicateOrder?.Clientes[0], fl_mto_prep: newType }],
      }),
    )
  }

  const handleClose = () => {
    setOpen(false)
    handleTypeChange(draftBody.fl_mto_prep)
  }

  useEffect(() => {
    if (draftBody?.fl_mto_prep) {
      setTypeMaterial(draftBody.fl_mto_prep)
      if (orderNumber) {
        dispatch(
          setDuplicateOrder({
            ...duplicateOrder,
            Clientes: [
              {
                cd_clie: draftBody.cd_clie,
                fl_dupl_matr: TypesValidations.YES,
                fl_dupl_text: TypesValidations.YES,
                fl_mto_prep: draftBody.fl_mto_prep,
                nr_pedi_clie: '',
              },
            ],
            cd_usua_alte: getUser(),
            nr_pedi_rasc_orig: String(orderNumber),
          }),
        )
      } else {
        dispatch(
          setDuplicateOrder({
            ...duplicateOrder,
            Clientes: [
              {
                cd_clie: draftBody.cd_clie,
                fl_dupl_matr: TypesValidations.YES,
                fl_dupl_text: TypesValidations.YES,
                fl_mto_prep: draftBody.fl_mto_prep,
                nr_pedi_clie: '',
              },
            ],
            cd_usua_alte: getUser(),
          }),
        )
      }
    }
  }, [orderNumber, draftBody?.fl_mto_prep])

  useEffect(() => {
    if (Object.keys(!duplicateOrder)?.length) {
      const clientes = {
        cd_clie: draftBody.cd_clie,
        fl_dupl_matr: TypesValidations.YES,
        fl_dupl_text: TypesValidations.YES,
        fl_mto_prep: draftBody.fl_mto_prep,
        nr_pedi_clie: draftBody.nr_pedi_clie,
      }
      const body = {
        Clientes: [clientes],
        cd_usua_alte: getUser(),
        nr_pedi_rasc_orig: orderNumber || '',
      }
      dispatch(setDuplicateOrder(body))
    }
  }, [])
  useEffect(() => {
    if (duplicateOrder?.Clientes?.length) {
      setTypeMaterial(duplicateOrder?.Clientes[0]?.fl_mto_prep as CustomBoolean)
    }
  }, [duplicateOrder?.Clientes])

  return (
    <Modal
      buttonAction={handleDuplicated}
      buttonIcon={<Icon icon="copy" size="15" />}
      buttonText="Duplicar"
      closeAction={handleClose}
      open={open}
      returnAction={handleClose}
      returnText="Cancelar"
      setOpen={setOpen}
      showReturn
      title="Duplicar Pedido"
    >
      <Container>
        <Content>
          <DescriptionWrapper>
            Você está duplicando o <strong>Pedido #{duplicateOrder?.nr_pedi_rasc_orig}</strong>.
            Para prosseguir, preencha os campos abaixo.
          </DescriptionWrapper>
        </Content>
        {
          //TODO: Verificar se esse campo será necessário para Duplicacao de pedidos e não de rascunhos
          false && (
            <Content>
              <ContentDate>
                <Label>Data de entrega</Label>
                <InputDate
                  onChange={(e) => {
                    setDataDelivery(e.target.value)
                    dispatch(
                      setDuplicateOrder({
                        ...duplicateOrder,
                        data_delivery: e.target.value,
                      }),
                    )
                  }}
                  placeholder="Data Inicial"
                  type="date"
                  value={dataDelivery}
                />
              </ContentDate>
            </Content>
          )
        }
        <Content>
          <Select
            defaultValue="N"
            focused={false}
            label="Tipo de material"
            name="select"
            onChange={(e) => {
              if (e.target.value) {
                handleTypeChange(e.target.value as CustomBoolean)
              }
            }}
            options={materialOptions}
            value={typeMaterial}
          />
        </Content>
        {showWarning && (
          <Content>
            <Alert
              fullWidth
              kind="warning"
              message="Ao alterar o tipo de material você poderá perder os materiais inseridos."
              title="Tipo de material alterado"
            />
          </Content>
        )}
        <Content>
          <Checkbox
            checked={keepMaterial}
            disabled={showWarning}
            label="Manter Materiais"
            onChange={(e) => {
              setKeepMaterial(e.target.checked)
              dispatch(
                setDuplicateOrder({
                  ...duplicateOrder,
                  Clientes: [
                    {
                      ...duplicateOrder?.Clientes[0],
                      fl_dupl_matr: e.target.checked ? TypesValidations.YES : TypesValidations.NO,
                    },
                  ],
                }),
              )
            }}
          />
        </Content>
        {
          //TODO: Verificar se esse campo será necessário para Duplicacao de pedidos e não de rascunhos
          false && (
            <Content>
              <Checkbox
                checked={false}
                label="Manter configuração do pedido"
                onChange={() => {
                  return
                }}
              />
            </Content>
          )
        }
      </Container>
    </Modal>
  )
}

export default ModalDuplicate
